$(document).ready(function() {
  let inventoryLevel;
  const shippingCountryCode = $('#product-grid-item').attr('data-shipping-country');
  let selectedVariantId = null;
  let selectedProductId = null;
  let variants = [];
  let isBulk = false;
  let bulkQty = 10;
   
  $(".add-to-bag_btn").click(function() {
    const $item = $(this);
    selectedProductId = $item.parents(".jw-product-item-swatch-v2").attr("data-product-id");
    const productHandle = $item.parents(".jw-product-item-swatch-v2").attr("data-product-handle");
    const currency = $item.siblings('.product-price').children('span.money').attr('data-shop-currency');
    const productTags = $item.parents(".jw-product-item-swatch-v2").attr("data-product-tags");
    isBulk = productTags.includes("bulk");
    
     jQuery.getJSON(window.Shopify.routes.root + `products/${productHandle}.js`, function(product) {
      let imageSrc = product.featured_image;
      const productTitle = product.title;
      variants = product.variants;
      
      addProductTitleAndImage(imageSrc, productTitle);
      showFreeShippingMinAmount(shippingCountryCode, currency);
      
      if (product.variants.length == 1) {
        selectedVariantId = product.variants[0].id;
        
        showAddedToCartModal();
        addItemToCart(selectedVariantId, isBulk);
      } else {
        let isVariantSelected = $item.siblings('.grid-product__metal').children('.swatch-picker.active').length > 0;
        selectedVariantId = $item.siblings('.grid-product__metal').children('.swatch-picker.active').data('variant');
        
        if (product.variants.length == 3 && product.variants[0].title.includes('Yellow Gold')) {
          if (!isVariantSelected) {
            showErrorMsg("Please choose a gold color");
            selectedProductId = null;
          } else {
            displayVariantOnAddedToCartModal()
            showAddedToCartModal();
            showVariantImage(variants, selectedVariantId);
            addItemToCart(selectedVariantId, isBulk)
          }
        } else {
          const price = Currency.formatMoney(product.price, Currency[Currency.format][currency]);

          $('.product__description .product-added__price').html(price);
          $('.view-details a').attr('href', product.url);
          if (isBulk) $('#bulk-msg').text(`*Sold in units of 10`);
          
          updateInventory(selectedProductId, shippingCountryCode);
          showSelectionModal();
          showVariantImages(product.media);
          showOptionsAndSizes(product.options);
          if (selectedVariantId) showSelectedGoldOptionToSelectionModal();
        }
      };
    });
  });
  
  $(".jp-close").click(function() {
    $('#side-modals').css("display", "none");
    $('.product__images .slider').empty();
    $('#bulk-msg').text("");
    selectedVariantId = null;
    removeAllOptions();
    //remove variant images
    $('.quick-add_btn.add-to-cart').addClass('disabled sold-out').text('Select all options');
    $('.quick-add_btn.add-to-cart').removeClass('add-to-cart');
  });
  
  $(".continue-shopping").click(function() {
    $('#side-modals').css("display", "none"); 
    $('.product__images .slider').empty();
    selectedVariantId = null;
    location.reload();
  });
  
  $(".add-to-cart").click(function() {
    if (!selectedVariantId) {
      showErrorMsg("Something went wrong. Please try again later.");
      return;
    }
    displayVariantOnAddedToCartModal();
    addItemToCart(selectedVariantId, isBulk);
    closeSelectionModal();
    removeAllOptions();
    showAddedToCartModal();
  });
  
  // Option change in Sidebar
  $(".product__options").on("click", ".option", function() {
    const $option = $(this);
    const $previouslySelectedOption = $option.siblings(".selected");
    
    $previouslySelectedOption.removeClass('selected');
    $option.addClass("selected");
    
    getSelectedVariant();
    updateAvailability(inventoryLevel, shippingCountryCode, selectedVariantId);
  });
  
  // Option change on collection level
  $('.grid-product__metal li.swatch-picker').click(function() {
    const $item = $(this);
    selectedVariantId = $item.data('variant');
    const productId = $(this).closest('.jw-product-item').data('product-id');
    getAvailability(productId, shippingCountryCode, selectedVariantId, $item);
  })
  
  $('.product__images').on("click",".thumbnail", function () {
    const $clickedImage = $(this);
    const clickedImageSrc = $clickedImage.attr("src");
    const $activeImage = $('.product__images .thumbnail.active');
    const $featuredImage = $('.product__description #featured');
    
    $activeImage.removeClass('active');
    $clickedImage.addClass('active');
    $featuredImage.attr('src', clickedImageSrc);
  })
  
  $('.slide-wrapper').on("click", ".slide-right", function () {
    const $button = $(this);
  	const $slider = $('.slider');
    $slider.animate({scrollLeft:'+=300'},500);
  })
  $('.slide-wrapper').on("click", ".slide-left", function () {
    const $button = $(this);
  	const $slider = $('.slider');
    $slider.animate({scrollLeft:'-=300'},500);
  })
  
  
  function getSelectedVariant () {
    let $selectedOptions = $(".product__options .options .option.selected");
    let selectedOptionValues = [];
    let foundVariant = false;

    $.each($selectedOptions, function(){
      const option = $(this).attr("option");
      selectedOptionValues.push(option);
    });
//     console.log("selected options", selectedOptionValues);
    variants.forEach(v => {
       if (selectedOptionValues.length == 1) {
        if (selectedOptionValues.includes(v.option1) || selectedOptionValues.includes(v.option2)) {
          selectedVariantId = v.id;  
          foundVariant = true;
        }
      } else if (selectedOptionValues.length == 2) {
        if (selectedOptionValues.includes(v.option1) && selectedOptionValues.includes(v.option2)) {
          selectedVariantId = v.id;  
          foundVariant = true;
        }
      } else if (selectedOptionValues.length == 3) {
        if (selectedOptionValues.includes(v.option1) && selectedOptionValues.includes(v.option2) && selectedOptionValues.includes(v.option3)) {
          selectedVariantId = v.id;
          foundVariant = true;
        }
      }
    });
    
    if (!foundVariant && !selectedVariantId) {
      $('.quick-add_btn.add-to-cart').removeClass('add-to-cart').addClass('disabled sold-out').text('Select all options');
      selectedVariantId = null;
    } else {
      $('.quick-add_btn.sold-out').removeClass('disabled sold-out').addClass('add-to-cart').text('Add to Cart');
    }
  }
  
  
  function addItemToCart(variant_id, isSoldInBulk) {
    //console.log("add item", variant_id);
    if (!variant_id) {
      showErrorMsg("Something went wrong. Please try again later.");
      return;
    }
    let formData = {
      'id': Number(variant_id),
      'quantity': isSoldInBulk ? 10 : 1 ,
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
//       console.log("response after adding item", response);
      updateCart(isSoldInBulk);
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
      showErrorMsg("Something went wrong. Please try again later.")
    });
  }

  function showAddedToCartModal() {
   const $itemInAlsoAdded = $('#also-added').find(`[data-id='${selectedProductId}']`);
   $itemInAlsoAdded.css("display", "none");
    
   $('#side-modals').css("display", "");
   $('#selection-modal').css("display", "none");
   $('#added-to-cart-modal').css("display", "");
   return;
  }

  function showSelectionModal() {
   $('#side-modals').css("display", "");
   $('#added-to-cart-modal').css("display", "none");
   $('#selection-modal').css("display", "");
   return;
  }

  function showVariantImage(variants, variant_id){
    let imageSrc = '';
    const variant = variants.forEach(variant => {
      if (variant.id == variant_id) {
        imageSrc = variant.featured_image.src;
      }
    });
    $('#item-added img').attr('src', imageSrc);
    return;
  }

  function addProductTitleAndImage(image, title){
   $('#item-added img').attr('src', image);
   $('#item-added .product-info .product-added__title').html(title);
   $('.product__description img').attr('src', image);
   $('.product__description .product-added__title').html(title);
    return;
  }

  function showVariantImages(images) {
    images.forEach((image, index) => {
      if(image.alt !== "no-display") {
        let imageEl = document.createElement("img");
        if (index === 0) {
          imageEl.setAttribute("class", "thumbnail active");
        } else {
          imageEl.setAttribute("class", "thumbnail");
        }
        imageEl.setAttribute("src", image.src);
        $('#selection-modal .product__images .slider').append(imageEl);
      }
    })
  }

  function showOptionsAndSizes(options) {
    const optionContainer = document.createElement('div');

    for (const option of options) {
      const optionNameEl = document.createElement('div');
      const optionValuesContainerEl = document.createElement('div');
      
      optionNameEl.className = 'name';
      optionValuesContainerEl.className = 'options';
      
      if (option.name === "Metal") {
        const optionValuesEl = document.createElement("ul");
        optionValuesEl.className = 'metal-options';
        
        optionNameEl.textContent = 'Gold Color';
        
        option.values.forEach(value => {
          let valueEl = document.createElement('li');
          if (value == "Yellow Gold") {
           valueEl.className = 'swatch-picker swatch-yellow-gold option';
          } else if (value == "White Gold") {
           valueEl.className = 'swatch-picker swatch-white-gold option';
          } else if (value == "Rose Gold") {
           valueEl.className = 'swatch-picker swatch-rose-gold option';
          }
          valueEl.setAttribute('option', value);
          optionValuesEl.append(valueEl);
        })
        optionValuesContainerEl.append(optionValuesEl);

        optionContainer.prepend(optionValuesContainerEl);
        optionContainer.prepend(optionNameEl);
        $('.product__options.container').prepend(optionContainer);
      } else {
        optionNameEl.textContent = option.name;
      
        option.values.forEach(value => {
           let valueEl = document.createElement("span");
           const optionTextNode = document.createTextNode(value);
           valueEl.setAttribute('option', value);
           valueEl.classList.add("option");
           valueEl.appendChild(optionTextNode);
           optionValuesContainerEl.append(valueEl);
        });

        optionContainer.append(optionNameEl);
        optionContainer.append(optionValuesContainerEl);
        $('.product__options.container').append(optionContainer);
      }
    }
  } 

  function removeAllOptions() {
    const optionsDOMs = document.getElementsByClassName("options");
    const optionNameDOMs = document.getElementsByClassName("name");
    Array.from(optionsDOMs).forEach(optionDOM => {
      optionDOM.innerHTML = '';
    })
    Array.from(optionNameDOMs).forEach(nameDOM => {
      nameDOM.innerHTML = '';
    })
  }

  function showFirstVariantAsSelectedByDefault(variants) {
    const variant = variants[0];
    const optionOne = variant.option1;
    const optionTwo = variant.option2;
    const optionThree = variant.option3 ?? null;

    const $optionOneItem = $(`.product__options .options__main .option[option='${optionOne}']`);
    $optionOneItem.addClass('selected');

    const $optionTwoItem = $(`.product__options .options__second .option[option='${optionTwo}']`);
    $optionTwoItem.addClass('selected');

    //console.log("option three: ",optionThree);
    if (optionThree) {
      const $optionThreeItem = $(`.product__options .options__third .option[option='${optionThree}']`);
      $optionThreeItem.addClass('selected');
    }

  }

  function updateInventory(productId, countryCode) {

    $.ajax({
      url        : theme.settings.apiBase + `/product/${productId}/inventory-level`,
      method     : "GET",
      dataType   : "json",
      contentType: "application/json",
      cache      : false,
    }).done((response) => {
      if (response.status === 'success' && response.inventory_levels && response.inventory_levels.length > 0) {
        inventoryLevel = response.inventory_levels;
      	updateAvailability(response.inventory_levels, countryCode, selectedVariantId);
       console.log(response.inventory_levels);
      }
    }).fail((error) => {
      console.log(error);
    });
  }

  function updateAvailability(inventoryLevels, countryCode, selectedVariantId) {
    
    if (!selectedVariantId) return;
    
    let isEuropeDistribution = countryCode !== '' ? theme.settings.euDistributionCountries.includes(countryCode) : theme.settings.euDistributionCountries.includes(theme.base.ipInfo.country);
    const locationId = isEuropeDistribution ? "35962519663" : "6349193327";
    
    $.getJSON('/cart.js', function(cart) {
      const cartItems = cart.items;
      const cartItem = cartItems.find(item => item.variant_id == selectedVariantId);
      const quantityInCart = cartItem ? cartItem.quantity : 0;
	  
      let variantInventory = inventoryLevels.find(inv => inv.location_id === locationId && inv.variant_id == selectedVariantId);
      const availableQty = variantInventory.available - quantityInCart;
       //console.log("ivneotry: ", variantInventory.available);
       //console.log("variant inv: ", variantInventory);

      if (availableQty <= 0) {
        $('.quick-add_btn.add-to-cart').addClass('disabled sold-out').text('Sold Out');
        $('.quick-add_btn.add-to-cart').removeClass('add-to-cart');
      } else {
        $('.quick-add_btn.sold-out').addClass('add-to-cart');
        $('.quick-add_btn.sold-out').removeClass('disabled sold-out').text('Add to Cart');
      }
    });
  }
  
  function closeSelectionModal() {
    $('#selection-modal').css("display", "none");
    return;
  }
  
  function getAvailability(productId, countryCode, variantId, $item) {
    //console.log("selected product Id", selectedProductId == productId)
    if (productId == selectedProductId) {
      if (inventoryLevel.length > 3) showAvailability(inventoryLevel, countryCode, productId, variantId);
    } else {
      selectedProductId = productId;
      
      $.ajax({
        url        : theme.settings.apiBase + `/product/${productId}/inventory-level`,
        method     : "GET",
        dataType   : "json",
        contentType: "application/json",
        cache      : false,
      }).done((response) => {
        if (response.status === 'success' && response.inventory_levels && response.inventory_levels.length > 0) {
          inventoryLevel = response.inventory_levels;
//           console.log("inventory level: ", response.inventory_levels);
          if (inventoryLevel.length > 3) showAvailability(inventoryLevel, countryCode, productId, variantId);      
        }
      }).fail((error) => {
        console.log(error);
      });
    }
  }
  
  function showAvailability(inventoryLevels, countryCode, productId, selectedVariantId) {
    let isEuropeDistribution = countryCode !== '' ? theme.settings.euDistributionCountries.includes(countryCode) : theme.settings.euDistributionCountries.includes(theme.base.ipInfo.country);
    const locationId = isEuropeDistribution ? "35962519663" : "6349193327";
    let totalQty = 0;
    
    const $item = $(`.jw-product-item[data-product-id='${productId}']`);
    const $button = $item.find('.quick-add_btn');

    let variantInventory = inventoryLevels.find(inv => inv.location_id === locationId && inv.variant_id == selectedVariantId);
    const availableQty = variantInventory.available;

    if (availableQty <= 0) {
      $button.addClass('disabled sold-out').text('Sold Out').removeClass('add-to-bag_btn');
    } else {
      $button.addClass('add-to-bag_btn').removeClass('disabled sold-out').text('Add to Cart');
    }
  }

  function displayVariantOnAddedToCartModal() {
    let variantName = '';
    const selectedVariant = variants.find(variant => variant.id === selectedVariantId)
    variantName = selectedVariant.name;
    // console.log(variantName);
    $('.product-added__variant').html(variantName);
  }

  function showSelectedGoldOptionToSelectionModal() {
    let options = [];
    const selectedVariant = variants.find(variant => variant.id === selectedVariantId);
    if (selectedVariant.option1) options.push(selectedVariant.option1);
    if (selectedVariant.option2) options.push(selectedVariant.option2);
    if (selectedVariant.option3) options.push(selectedVariant.option3);

    options.forEach(option => {
      if (option === 'Yellow Gold' || option === 'White Gold' || option === 'Rose Gold') {
        $(`.product__options .options ul.metal-options .swatch-picker[option='${option}']`).addClass('selected');
      } else {
        $(`.product__options .options .option[option='${option}']`).addClass('selected'); 
      }
    })
  }
});

function showFreeShippingMinAmount(clientCountryCode, clientCurrency) {

  $.ajax({
    url        : theme.settings.apiBase + "/shipping-zones/rates",
    method     : "GET",
    dataType   : "json",
    contentType: "application/json",
    cache      : false,
  }).done((response) => {
    if (response.status === 'success' && response.message && response.message.length > 0) {
      const freeShippingRate = this.findFreeShippingRate(response.message, clientCountryCode);
     //console.log("response: ", response.message);
     //console.log('shipping: ', freeShippingRate);
      const freeShippingMinAmount = freeShippingRate.min_order_subtotal*100;
      const freeShippingMinAmountText = Currency.formatMoney(freeShippingMinAmount, Currency[Currency.format][clientCurrency]);
      const freeShippingMinAmountFullText = freeShippingRate ? `Get free shipping over ${freeShippingMinAmountText}` : "Ships next business day";
      //console.log("freeShippingMinAmountText", freeShippingMinAmountFullText)
      $('#free-shipping-min-amount').html(freeShippingMinAmountFullText);
    }
  }).fail((error) => {
    console.log("couldn't get shipping rates: ",error);
  })
}

function findFreeShippingRate(shipping_zones, countryCode) {
  if (!countryCode) countryCode = theme.base.ipInfo.country;
 // console.log("country code: ", countryCode)
  let freeShippingRate;
  for (const zone of shipping_zones){
    const countries = zone.countries;
    const countryIndex = countries.findIndex(country => country.code == countryCode);
    if (countryIndex == -1) {
      continue;
    } else {
      const shippingRates = zone.price_based_shipping_rates;
      // console.log("countries:", countries)
      // console.log("shipping rates:", shippingRates)
      freeShippingRate = shippingRates.find(rate => rate.price == "0.00" && rate.min_order_subtotal) || {};
      // console.log("free shipping rate exist?", freeShippingRate)
      if (Object.keys(freeShippingRate).length > 0) return freeShippingRate;
    }
  }
}

function updateCart(isSoldInBulk) {
  const $collection = $('#CollectionSection');
  const $currentCartCount = $collection.parents('#MainContent').siblings('#navbar').find('.cart-item__count');
  const added = isSoldInBulk ? 10 : 1;
  const cartCountNow = Number($currentCartCount.text()) + added;
  
  $currentCartCount.text(cartCountNow);
}

function showErrorMsg(msg) {
  $('#error-msg').css("display", "");
  $('#error-msg p').text(msg);
}


